module.exports = __webpack_public_path__ + "static/media/hover_image_image.58a9f113.png";